import React from 'react';
import { Field } from 'formik';
import { CustomSelectComponent } from 'motion-components';
import { useTranslation } from 'react-i18next';

/* ----------- Select Month ------------------ */
export const SelectMonth = ({ required = false, name = 'month', title = 'Month', ...rest }) => {
  const { t } = useTranslation();
  const monthOptions = [
    { value: 1, label: t('Ιανουάριος') },
    { value: 2, label: t('Φεβρουάριος') },
    { value: 3, label: t('Μάρτιος') },
    { value: 4, label: t('Απρίλιος') },
    { value: 5, label: t('Μάιος') },
    { value: 6, label: t('Ιούνιος') },
    { value: 7, label: t('Ιούλιος') },
    { value: 8, label: t('Αύγουστος') },
    { value: 9, label: t('Σεπτέμβριος') },
    { value: 10, label: t('Οκτώβριος') },
    { value: 11, label: t('Νοέμβριος') },
    { value: 12, label: t('Δεκέμβριος') },
  ];

  return (
    <Field
      {...rest}
      required={required}
      name={name}
      title={t(title)}
      component={CustomSelectComponent}
      options={monthOptions}
    />
  );
};

